import React from "react";

import { Container } from "@components/Container/Container";
import styles from "./styles.module.scss";
import { Heading } from "@components/Heading/Heading";
import { Text } from "@components/Text/Text";
import { Module } from "@components/Module/Module";

export interface CitatProps {
  citat: {
    Person: string;
    PersonTitle: string;
    Quote: string;
    Key: string;
  };
}

const Citat: React.FC<CitatProps> = ({ citat }) => {
  return (
    <Module animate>
      <Container variant="small">
        <blockquote className={styles.citat}>
          {citat.Quote && (
            <Heading as="h2" className={styles.heading}>
              {citat.Quote}
            </Heading>
          )}
          {citat.Person && (
            <Text className={styles.text}>
              {`${citat.Person}${citat.PersonTitle && `, `}`}

              {citat.PersonTitle && (
                <span className={styles.persontitle}>{citat.PersonTitle}</span>
              )}
            </Text>
          )}
        </blockquote>
      </Container>
    </Module>
  );
};

export { Citat };
